/* src/app/yard-trade-signoff/pages/yard-trade-signoff/yard-trade-signoff.component.scss */
/*# sourceMappingURL=yard-trade-signoff.component.css.map */
